import { Route, Routes } from 'react-router-dom';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import PrivateRoute from './components/PrivateRoute';
import { UserProviderId, UserRole } from 'models/IUser';
import LiteralsPage from './pages/admin/LiteralsPage';
import ProfilePage from './pages/settings/SettingsPage';
import LoginPage from './pages/login/LoginPage';
import UsersPage from './pages/admin/UsersPage';
import NotFoundPage from './pages/maintenance/404';
import 'app/i18n';
import PatientsPage from 'pages/patients/PatientsPage';
import DevicesPage from 'pages/admin/DevicesPage';
import OrganizationsPage from 'pages/admin/OrganizationsPage';
import NotificationsPage from 'pages/notifications/NotificationsPage';
import ForgotPasswordPage from 'pages/login/ForgotPasswordPage';
import ResetPasswordPage from 'pages/login/ResetPasswordPage';
import FitbitPage from 'pages/fitbit/FitbitPage';
import CoveragePage from 'pages/coverage/CoveragePage';
import { HubsProvider } from 'features/webpubsub/HubsManager';
import PatientFileResolverPage from 'pages/patients/PatientFileResolverPage';

const App = () => {
  return (
    <ThemeCustomization>
      <ScrollTop>
        <Notistack>
          <HubsProvider>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="forgot-password" element={<ForgotPasswordPage />} />
              <Route path="reset-password" element={<ResetPasswordPage />} />
              <Route path="fitbit" element={<FitbitPage />} />
              <Route path="admin/devices" element={<PrivateRoute authenticationPath="/login" outlet={<DevicesPage />} />} />
              <Route path="admin/organizations" element={<PrivateRoute authenticationPath="/login" outlet={<OrganizationsPage />} />} />
              <Route path="admin/users" element={<PrivateRoute authenticationPath="/login" outlet={<UsersPage />} />} />
              <Route path="admin/literals" element={<PrivateRoute authenticationPath="/login" allowedRoles={[UserRole.Admin]} outlet={<LiteralsPage />} />} />
              <Route path="profile" element={<PrivateRoute authenticationPath="/login" outlet={<ProfilePage />} />} />
              <Route path="patients" element={<PrivateRoute authenticationPath="/login" outlet={<PatientsPage />} />} />
              <Route path="patients/:userid/file" element={<PrivateRoute authenticationPath="/login" outlet={<PatientFileResolverPage />} />} />
              <Route path="coverage" element={<PrivateRoute authenticationPath="/login" allowedRoles={[UserRole.Admin, UserRole.Manager]} allowedProviders={[UserProviderId.EXCARE]} outlet={<CoveragePage />} />} />
              <Route path="notifications" element={<PrivateRoute authenticationPath="/login" outlet={<NotificationsPage />} />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <Snackbar />
          </HubsProvider>
        </Notistack>
      </ScrollTop>
    </ThemeCustomization>
  );
};

export default App;